import React, { useState, useEffect } from 'react';
import AdminTemplate from 'components/templates/AdminTemplate';
import { Grid, Typography } from '@material-ui/core';
import ModalContainer from 'components/molecules/ModalContainer';
import IMWarehouseList from 'components/organisms/IMWarehouseList';
import IMWarehouseForm from 'components/organisms/IMWarehouseForm';
import IMWarehouseDeleteModal from 'components/organisms/IMWarehouseDeleteModal';
import useWarehouseIM from 'hooks/useWarehouseIM';
import { IWareHouseList } from 'interfaces/imWarehouse.interface';

export default function IMWarehouse() {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [warehouseId, setWarehouseId] = useState('');
  const { getWarehouses, addWarehouse, updateWarehouse } = useWarehouseIM();
  const [warehouses, setWarehouses] = useState<any>([]);

  const handleOnCloseModal = () => {
    setOpenModalEdit(false);
  };

  const getAllWarehouses = () => {
    setIsLoading(true);
    getWarehouses()
      .then((result: IWareHouseList[]) => {
        if (result !== undefined && result.length > 0) {
          setWarehouses(result);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const saveWarehouse = (data: any) => {
    if (data.id) {
      return updateWarehouse(data);
    } else {
      return addWarehouse(data);
    }
  };

  const handleOnClickEditWarehouse = (warehouseId: string) => {
    setWarehouseId(warehouseId);
    setOpenModalEdit(true);
  };

  const handleOnClickDeleteWarehouse = (warehouseId: string) => {
    setWarehouseId(warehouseId);
    setOpenDeleteModal(true);
  };

  const addWareHouseButton = () => {
    setWarehouseId('');
    setOpenModalEdit(true);
  };

  useEffect(() => {
    getAllWarehouses();
  }, []);

  return (
    <AdminTemplate>
      <Grid container justify="center" spacing={2}>
        <Grid item xs={12} sm={12}>
          <Typography variant="h5" component="h1" align="center">
            Gestión de Bodegas
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={10}>
          <IMWarehouseList
            handleOnClickEditWarehouse={handleOnClickEditWarehouse}
            handleOnClickDeleteWarehouse={handleOnClickDeleteWarehouse}
            addWareHouseButton={addWareHouseButton}
            IMWarehouseList={warehouses}
            isLoading={isLoading}
          />
        </Grid>
        <ModalContainer title="Crear bodega" open={openModalEdit} onClose={handleOnCloseModal}>
          <IMWarehouseForm
            handleCloseModal={handleOnCloseModal}
            handleOnSubmit={saveWarehouse}
            warehouseId={warehouseId}
            getAllWarehouses={getAllWarehouses}
          />
        </ModalContainer>
        <IMWarehouseDeleteModal
          onClose={() => {
            setOpenDeleteModal(!openDeleteModal);
          }}
          open={openDeleteModal}
          warehouseId={warehouseId}
          getAllWarehouses={getAllWarehouses}
        />
      </Grid>
    </AdminTemplate>
  );
}
